import React, { Component } from 'react'
import {
    Row, Col
} from 'reactstrap'
// import logoMAPFRE from '../../imgs/mapfre_logo.png'
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_phone } from 'react-icons-kit/md/ic_phone'
import { instagram } from 'react-icons-kit/fa/instagram'
import { facebookSquare } from 'react-icons-kit/fa/facebookSquare'
import { linkedinSquare } from 'react-icons-kit/fa/linkedinSquare'
import { twitterSquare } from 'react-icons-kit/fa/twitterSquare'
import { envelope } from 'react-icons-kit/fa/envelope'
import './footer.css'
import InfoEmpresaObj from '../../utils/empresa'
const empresa = new InfoEmpresaObj()

export default class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            infoEmpresa: {}
        }
    }

    componentWillMount() {
        const _this = this
        empresa.getInfoEmpresa().then(infoEmpresa => {
            _this.setState({
                infoEmpresa
            })
        })
    }

    formatTel(txt = ''){
        if(txt.length > 1){
            return txt.substr(1)
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="Footer">
                    <div className="FooterContent">
                        {/* <Row className="footerSocial">
                            <Col>
                                <div className="float-right">
                                    visitanos en:
                            </div>
                            </Col>
                        </Row> */}
                        <Row>
                            <Col sm={9} md={10} className="logoMAPFRE">
                                <div className="logoNombre">
                                    Matías Chenlo,
                                </div>
                                <div className="logoProfesion">
                                    Asesor de seguros
                                </div>
                                <div className="logoNombre">
                                    MAPFRE
                                </div>
                                {/* <img className="float-right" src={logoMAPFRE} alt="Logo MAPFRE" /> */}
                            </Col>
                            <Col sm={3} md={2}>
                                <div>
                                    <a className="navlink" href={`tel:+598${this.formatTel(this.state.infoEmpresa.Telefono)}`}>
                                        <Icon size={30} icon={ic_phone} />
                                        <span>{this.state.infoEmpresa.Telefono}</span>
                                    </a>
                                </div>
                                {
                                    this.state.infoEmpresa.Facebook &&
                                    <a className="navlink" target="_blank" href={`${this.state.infoEmpresa.Facebook}`}>
                                        <Icon size={30} icon={facebookSquare} />
                                    </a>
                                }
                                {
                                    this.state.infoEmpresa.Instagram &&
                                    <a className="navlink" target="_blank" href={`${this.state.infoEmpresa.Instagram}`}>
                                        <Icon size={30} icon={instagram} />
                                    </a>
                                }
                                {
                                    this.state.infoEmpresa.Linkedin &&
                                    <a className="navlink" target="_blank" href={`${this.state.infoEmpresa.Linkedin}`}>
                                        <Icon size={30} icon={linkedinSquare} />
                                    </a>
                                }
                                {
                                    this.state.infoEmpresa.Twitter &&
                                    <a className="navlink" target="_blank" href={`${this.state.infoEmpresa.Twitter}`}>
                                        <Icon size={30} icon={twitterSquare} />
                                    </a>
                                }

                                <Link className="navlink" to="/contacto/">
                                    <Icon size={30} icon={envelope} />
                                </Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="dev">
                                © 2019 CHENLOSEGUROS 
                                {/* <a href="mailto:brianbentancourt9@gmail.com?Subject=Hello%20again" target="_top"> brianbentancourt9@gmail.com</a> */}
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}